import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const TableAnalyticExplainer = ({
  aggregationType,
  label
}) => {
  const i18nKey = `reporting-visualizations.analytic-explainer.aggregations.${aggregationType}.description`;
  if (!isValidI18nKey(i18nKey)) {
    return null;
  }
  return /*#__PURE__*/_jsx(HelpIcon, {
    title: /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(View, {
        marginInline: "auto",
        marginBlock: "200",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: i18nKey
        })
      })
    }),
    tooltipProps: {
      headingText: label,
      use: 'longform',
      placement: 'bottom'
    },
    alignWithText: true
  });
};
export default TableAnalyticExplainer;